import moment from 'moment';
import * as colorDispoFace from '@/configuration/colorDispoFaces';

export default function decorate(cellule, dispo, produitPanier) {
  const resteAVendre = dispo.stock - dispo.vendu;
  if (resteAVendre <= 0) {
    cellule.fill = dispo.jourDeLaSemaine === 6 || dispo.jourDeLaSemaine === 0
      ? colorDispoFace.ANY_DISPO_WEEKEND : colorDispoFace.ANY_DISPO;
    cellule.stroke = dispo.jourDeLaSemaine === 6 || dispo.jourDeLaSemaine === 0
      ? colorDispoFace.ANY_DISPO_WEEKEND : colorDispoFace.ANY_DISPO;
    cellule.textColor = colorDispoFace.IS_DISPO;
  } else if (dispo.vendu === 0) {
    cellule.fill = dispo.jourDeLaSemaine === 6 || dispo.jourDeLaSemaine === 0
      ? colorDispoFace.IS_WEEKEND : colorDispoFace.IS_DISPO;
    cellule.textColor = colorDispoFace.COLOR_TEXT_DISPO;
    cellule.stroke = colorDispoFace.STROKE_DISPO;
  } else {
    cellule.textColor = colorDispoFace.IS_DISPO;
    cellule.fill = dispo.jourDeLaSemaine === 6 || dispo.jourDeLaSemaine === 0
      ? colorDispoFace.PARTIEL_DISPO_WEEKEND : colorDispoFace.PARTIEL_DISPO;
    cellule.stroke = dispo.jourDeLaSemaine === 6 || dispo.jourDeLaSemaine === 0
      ? colorDispoFace.PARTIEL_DISPO_WEEKEND : colorDispoFace.PARTIEL_DISPO;
  }
  if (produitPanier) {
    let dateSelectionnee;
    const dateCase = moment(dispo.date);
    produitPanier.periode.forEach((el) => {
      if (dateCase.isBetween(el.dateDebut, el.dateFin, 'day', '[]') && produitPanier.produitId === dispo.produitId) {
        dateSelectionnee = true;
      }
    });
    if (dateSelectionnee === true) {
      cellule.selected = true;
    }
    const casePresente = produitPanier.periode.find((el) => {
      return dateCase.isBetween(el.dateDebut, el.dateFin, 'day', '[]');
    });
    if (casePresente) {
      if (casePresente.produitLocationNum.saturation === 1) {
        cellule.texte = 'F';
      } else if (casePresente.produitLocationNum.saturation === 2) {
        cellule.texte = 'A';
      }
    }
  }
  cellule.key = `${dispo.produitId}|${dispo.date}`;
}
